<template>
  <v-btn
    flex-row-reverse
    :disabled="isDisabled"
    :loading="loading"
    icon
    @click="confirmTerminate()"
  >
    <v-icon>
      mdi-download-box-outline
    </v-icon>
  </v-btn>
</template>

<script>
import ReportComponentVue from '@/app/arch/components/crud/components/ReportComponent.vue';
import ReportsRequest from '../ReportsRequest';

export default {
  name: 'ReportTerminate',
  extends: ReportComponentVue,
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    row: {
      type: Object,
      default() {
        return {
          status: '',
        };
      },
    },
  },
  data: () => ({
    requestClass: ReportsRequest,
    dialogTitle: 'Baixar relatório?',
    dialogText: 'Deseja baixar como csv o relatório',
    successMessage: 'Sucesso ao solicitar download de relatório',
    crudListName: 'ReportsList',
    failMessage: 'Falha ao solicitar download de relatório',
  }),
  computed: {
    proxyRequest() {
      return () => this.getReport(this.getId);
    },
    getId() {
      return this.value;
    },
    isDisabled() {
      return this.getStatus !== 'Finished';
    },
    getStatus() {
      return this.row.status;
    },
  },
  methods: {
    getReport(id) {
      return new Promise(
        (resolve, reject) => {
          this.makeReportRequest(id, resolve, reject);
        },
      );
    },
    async makeReportRequest(id, resolve, reject) {
      const details = await this.getReportDetails(id, reject);
      const url = await this.getReportUrl(details.fileName, reject);

      this.getReportDataFile(url, resolve);
    },
    async getReportDetails(id, reject) {
      const details = await this.requestClass.get(id)
        .then(
          (res) => res.data,
        ).catch(reject);
      this.guardError(!this.hasFileName(details), reject);
      return details;
    },
    hasFileName(details) {
      return details && details.fileName;
    },
    async getReportUrl(fileName, reject) {
      const url = await this.requestClass.report(fileName)
        .then((res) => res.data)
        .catch(reject);
      this.guardError(!url, reject);
      return url;
    },
    guardError(conditional, reject) {
      if (conditional) { reject(new Error(this.failMessage)); }
    },
    getReportDataFile(url, resolve) {
      const link = document.createElement('a');
      link.target = '_blank';
      link.href = new URL(url);
      link.click();
      link.remove();
      resolve({});
    },
    makeTerminateResponse(res) {
      console.log(res);
      return res;
    },
  },
};
</script>
